import { ListItemType } from 'common/types/charts';
import { FolderType } from 'common/types/folders';

export const getFolderType = (type: ListItemType): FolderType =>
  type === ListItemType.DASHBOARDS ? FolderType.Dashboard : FolderType.Chart;

export const getItemDataProperty = (type: ListItemType): 'chartId' | 'dashboardId' =>
  type === ListItemType.DASHBOARDS ? 'dashboardId' : 'chartId';

export const getUrlPrefix = (type: ListItemType): 'dashboard' | 'chart' => (type === ListItemType.DASHBOARDS ? 'dashboard' : 'chart');
